
























































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';
import PagesBtn from '@/views/auth/components/Btn.vue';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---

@Component({
  components: {
    BaseMaterialCard,
    PagesBtn,
  },
})
export default class PagesLogin extends Vue {
  user = {
    username: '',
    password: '',
  };

  valid: boolean = false;
  clicked: boolean = false;
  showPassword: boolean = false;
  
  rules = {
      required: (value: string) => !!value || '',
  };

  // Functions

  beforeMount() {
    /*
    // have moved this back into AuthService.Logout

    if (this.$store.getters['users/loggedInUser'] && this.$store.getters['users/loggedInUser'].loggedIn) {
      // if we have a user now, empty the store because we probably came from Logout
      this.$store.dispatch('app/reset');
      this.$store.dispatch('users/resetLoggedInUser', {});
    }
    */
  }

  async login() {
    try {
      this.clicked = true;

      const response = await AuthService.login(this.user);

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          // check the domain
          if (response.data.domain === process.env.VUE_APP_SUBDOMAIN) {
            this.$router.push({ name : 'Check Register Routing' });
          } else {
            window.location.href = 'http://' + response.data.domain + '.onlinecareerguidance.co.za/register/check';
          }
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.clicked = false;
    }
  }
}
